export default "__VITE_ASSET__d92ea701__"